module.exports = __webpack_public_path__ + "cc1f34db669a1761ccf242af943ed439.png";